import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const Register = () => {
  const [formData, setFormData] = useState({ username: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(formData.username, formData.email, formData.password);
      toast.success('Registro exitoso. Por favor inicia sesión.');
      navigate('/admin/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error en el registro');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-12">
          <h1 className="font-['Playfair_Display'] text-3xl tracking-tighter">HAUTE</h1>
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 mt-2">Admin Registration</p>
        </Link>
        
        <div className="bg-[#0A0A0A] border border-white/10 p-8">
          <h2 className="text-xl font-semibold mb-6 text-center">Registrarse</h2>
          
          <form onSubmit={handleSubmit} data-testid="register-form">
            <div className="mb-6">
              <label className="block text-xs uppercase tracking-[0.2em] mb-3 text-white/80">Usuario</label>
              <input
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({...formData, username: e.target.value})}
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none px-0 py-4 text-white"
              />
            </div>
            
            <div className="mb-6">
              <label className="block text-xs uppercase tracking-[0.2em] mb-3 text-white/80">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none px-0 py-4 text-white"
              />
            </div>
            
            <div className="mb-8">
              <label className="block text-xs uppercase tracking-[0.2em] mb-3 text-white/80">Contraseña</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none px-0 py-4 text-white"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black hover:bg-gray-200 transition-colors duration-300 rounded-none px-10 py-5 uppercase tracking-widest text-xs font-semibold"
            >
              {loading ? 'Registrando...' : 'Registrarse'}
            </button>
          </form>
          
          <p className="text-xs text-center text-white/60 mt-6">
            ¿Ya tienes cuenta? <Link to="/admin/login" className="text-white underline">Iniciar Sesión</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
